import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Landing from './landing.js';
import Types from './types.js';
import Gallery from './gallery.js';
import Documentation from './documentation.js';
import NotFound from './notFound.js';

const Main = () => {
  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route path="/types" component={Types} />
      <Route path="/gallery" component={Gallery} />
      <Route path="/documentation" component={Documentation} />
      <Route component={NotFound} />
    </Switch>
  );
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.js